<template>
  <div class="footer3">
    <van-button class="footerbtn" type="danger" @click="subConFirm">确认</van-button>
  </div>
</template>

<script>
export default {
  name: 'footer3',
  data() {
    return {}
  },
  methods: {
    subConFirm() {
      this.$emit('subConFirm')
    }
  }
}
</script>

<style lang="less" scoped>
.footer3{
  width: 100%;
  height: 160px;
  background: #FFFFFF;
  box-shadow: 0px 1px 48px 2px rgba(224,224,224,0.41);
  position:fixed;
  bottom:0px;
  z-index:2;
  padding-top:20px;
  text-align:center;
  .footerbtn{
    width: 193px;
    height: 79px;
    background: #333333;
    border-radius: 40px;
    border: 0px solid #F099BA;
    font-weight: 400;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 49px;
    margin:0px auto;
  }
}
</style>
